import { atom } from 'recoil';
import { Settings } from '../interfaces/Settings/Settings';

export const settingsAtom = atom<Settings>({
  key: 'settingsState',
  default: {
    settingsV1: {},
    storeSettings: {},
    menu: [],
    footer1: [],
    footer2: [],
  },
});
